export enum ShippingMethod {
    courier = 'COURIER',
    locker = 'PACZKOMAT'
}

export type ShippingType = ShippingMethod;
